export const ACCESSORIES_NAV_IMG_PATH = process.env.NODE_ENV === 'development'
    ? 'https://assets-static-dev.displate.com/header/accessories'
    : 'https://assets-static-prod.displate.com/header/accessories';
//# sourceMappingURL=constants.js.map